import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=08fc2c7c&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=js"
export * from "./MainDashboard.vue?vue&type=script&lang=js"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&id=08fc2c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc2c7c",
  null
  
)

export default component.exports